<template>
  <div class="">
    <div class="fixed top-0 left-0 right-0 flex justify-center py-5 bg-white">
      <img src="/assets/images/LoanSpot-logo.svg" alt="" class="">
    </div>
    <div class="bg-404 w-full h-screen pt-20 px-4 md:pt-30 lg:pt-40">
      <div class="w-full max-w-md mx-auto bg-white rounded-2xl">
        <div class="flex items-center justify-end w-full rounded-t-2xl px-6 bg-accent-3 h-9">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="4" r="4" fill="white"/>
          </svg>
          <svg class="mx-1" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="4" r="4" fill="white"/>
          </svg>
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="4" r="4" fill="white"/>
          </svg>
        </div>
        <div class="p-6 bg-white rounded-b-2xl">
          <div class="rounded-lg border border-border h-77.5 flex flex-col items-center justify-center">
            <div class="flex w-3/5 sm:w-full justify-center">
              <svg width="63" height="73" viewBox="0 0 63 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M49.3305 53.2171L61.3013 52.38L60.4977 40.8881L48.7184 41.7118L45.8657 0.915366L28.0532 2.16094L3.5704 45.6387L4.32042 56.3645L36.3063 54.1278L37.4581 70.5996L50.4823 69.6889L49.3305 53.2171ZM33.3692 14.8771L35.3112 42.6493L17.0199 43.9283L33.3692 14.8771Z" fill="#121F3E"/>
              </svg>
              <svg width="66" height="79" viewBox="0 0 66 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.8 74.7011C36.1658 75.8768 43.2613 73.6749 49.0999 68.0002C54.9251 62.4206 58.5993 54.2121 60.1224 43.3746C61.6321 32.6322 60.3629 23.7289 56.3146 16.6647C52.253 9.69564 46.0527 5.52816 37.6869 4.35243C29.131 3.14997 22.0221 5.44696 16.1969 11.0266C10.3583 16.7012 6.77921 24.9231 5.26946 35.6655C3.74635 46.503 4.92054 55.393 8.98216 62.362C13.0304 69.4262 19.2441 73.4986 27.8 74.7011ZM36.0035 16.3307C40.2814 16.9319 43.3148 19.491 45.0352 23.8044C46.7556 28.1178 47.0948 33.9821 46.0527 41.3972C45.0105 48.8124 43.0548 54.451 40.212 58.1232C37.3693 61.7953 33.7614 63.324 29.4835 62.7228C25.1104 62.1082 22.0637 59.6442 20.3433 55.3308C18.6229 51.0174 18.2837 45.1531 19.3392 37.6429C20.3813 30.2278 22.3371 24.5891 25.1798 20.917C28.0226 17.2449 31.6304 15.7161 36.0035 16.3307Z" fill="#121F3E"/>
              </svg>
              <svg width="71" height="80" viewBox="0 0 71 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M47.5662 60.6516L59.304 63.1465L61.6991 51.8782L50.1491 49.4232L58.6519 9.4209L41.1861 5.70842L5.66764 40.7535L3.43218 51.2706L34.7955 57.9371L31.3625 74.0882L44.1332 76.8027L47.5662 60.6516ZM42.7911 19.3973L37.0028 46.6289L19.0675 42.8166L42.7911 19.3973Z" fill="#121F3E"/>
              </svg>
            </div>
            <p class="mt-4 leading-4 w-50 sm:w-62.5 text-center text-title">There seems to have been an error loading this page.</p>
            <router-link to="/" class="mt-8 py-4.5 rounded-lg bg-primary text-white text-center w-50 sm:w-60 font-family-semibold">Return to home page</router-link>
          </div>
        </div>          
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
.bg-404 {
  background-image: linear-gradient(154.89deg, #5B7BFD -0.2%, #3752C1 82.72%);
}
</style>